import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { getCoreDataSecurityAccessExplainerByObjectIdSlice } from './get';

export const coreDataSecurityAccessExplainerByObjectIdReducers = combineReducers({
	get: getCoreDataSecurityAccessExplainerByObjectIdSlice.asyncReducers
});

export const coreDataSecurityAccessExplainerByObjectIdWatchers = combineAllWatchers([
	getCoreDataSecurityAccessExplainerByObjectIdSlice.asyncWatchers
]);
